<div [style.width]="this.isTabTopLevel ? this.tableWidth : '100%'" [style.height]="this.tableHeight">
  <ag-grid-angular
    #agGrid
    style="width: 100%; height: 100%"
    id="myGrid"
    class="ag-theme-balham"
    (cellClicked)="onCellClicked($event)"
    (rowSelected)="onRowSelected($event)"
    (toolPanelVisibleChanged)="toolPanelVisibleChanged()"
    (rowGroupOpened)="onRowGroupOpened($event)"
    (cellEditingStopped)="onCellEditingStopped($event)"
    [animateRows]="false"
    [cacheBlockSize]="cacheBlockSize"
    [columnDefs]="columnsTableHeader"
    [frameworkComponents]="this.data.frameworkComponents"
    [getContextMenuItems]="getContextMenuItems"
    [localeText]="localeText"
    [multiSortKey]="'ctrl'"
    [pagination]="true"
    [paginationAutoPageSize]="!isMobile && !isInSpecificOrNotLvl0"
    [paginationPageSize]="paginationPageSize"
    (paginationChanged)="onPageChange()"
    [rowModelType]="'serverSide'"
    [rowMultiSelectWithClick]="rowMultiSelectWithCLick"
    [rowSelection]="rowSelection"
    [sideBar]="sideBar"
    [icons]="icons"
    [suppressColumnVirtualisation]="true"
    [suppressRowClickSelection]="suppressRowClickSelection"
    [statusBar]="statusBar"
    [modules]="modules"
    [rowClassRules]="rowClassRules"
    [enableBrowserTooltips]="true"
    (gridReady)="onGridReady($event)"
    [defaultColDef]="defaultColDef"
    [defaultColGroupDef]="defaultColGroupDef"
  ></ag-grid-angular>
</div>
